import { render, staticRenderFns } from "./ResearchHeatmapVector.vue?vue&type=template&id=8060dc48"
import script from "./ResearchHeatmapVector.vue?vue&type=script&lang=js"
export * from "./ResearchHeatmapVector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8060dc48')) {
      api.createRecord('8060dc48', component.options)
    } else {
      api.reload('8060dc48', component.options)
    }
    module.hot.accept("./ResearchHeatmapVector.vue?vue&type=template&id=8060dc48", function () {
      api.rerender('8060dc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchHeatmapVector.vue"
export default component.exports